import { render, staticRenderFns } from "./TabProfileCoverage.vue?vue&type=template&id=6ce7e8df"
import script from "./TabProfileCoverage.vue?vue&type=script&lang=js"
export * from "./TabProfileCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports